import map from 'lodash/map'
import React from 'react'
import { Row } from './Row'
import { DataSuspense } from '@ztechapps/webui.util'
import { LoadMoreButton } from '@ztechapps/webui.button'
import { OrderListEmptyContent } from './OrderListEmptyContent'
import { TabName } from './TabName'
import { useOrderListContext } from './Context'

export const OrderTable = ({ tabName = TabName.all }: { tabName: TabName }) => {
  const orderListContext = useOrderListContext()

  const { list, error, loading, pageInfo, loadMoreEntries, sort, filter, isEmpty } =
    orderListContext.orderLists[tabName].orderList

  return (
    <DataSuspense
      emptyComponent={<OrderListEmptyContent tabName={tabName} />}
      error={error}
      loading={loading}
      isEmpty={isEmpty}
    >
      <table className="table table-hover table-responsive-lg">
        <thead className="thead-light">
          <tr>
            <th style={{ width: '70%' }}>Order Summary</th>
            <th>Order Date</th>
            <th className="text-end">Net Amount</th>
          </tr>
        </thead>
        <tbody>
          {map(list, (order, index) => (
            <Row key={order?._id ?? index} {...order} />
          ))}
        </tbody>
      </table>
      <LoadMoreButton {...{ dataArray: list, pageInfo, loadMoreEntries, loading, sort, filter }} />
    </DataSuspense>
  )
}
